import React from 'react';
import { Form, Grid, Segment, Label, Button, Icon, Image, Input } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import TRANSLATIONS from '@translations/translationNamespaces';
import { TranslatableTextField, TranslatableRichTextField } from '../../../../../components';
import VALID_IMAGE_MIME_TYPES from '../../../../models/ImageTypes';
import GridElementItemModel from '../../../../models/elementModels/GridElementModel/GridElementItemModel';

class GridElement extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onAddGridItem = this.onAddGridItem.bind(this);
    this.onRemoveGridItem = this.onRemoveGridItem.bind(this);
    this.onArrowUp = this.onArrowUp.bind(this);
    this.onArrowDown = this.onArrowDown.bind(this);
    this.onChangeTranslatableContent = this.onChangeTranslatableContent.bind(this);
    this.onUploadIcon = this.onUploadIcon.bind(this);
  }

  onChangeTranslatableContent(e, { name, value, language, innerElementPosition }) {
    const { onChange, sectionNumber, element } = this.props;

    onChange(prevState => ({
      offerSections: prevState.offerSections.reduce((acc, section) => {
        if (section.position === sectionNumber) {
          return acc.concat([
            {
              ...section,
              elements: section.elements.reduce((elementsAcc, el) => {
                if (element.position === el.position) {
                  return elementsAcc.concat([
                    {
                      ...el,
                      elements: (el.elements || []).reduce((innerElementsAcc, innerElement) => {
                        if (innerElement.position === innerElementPosition) {
                          return innerElementsAcc.concat([
                            {
                              ...innerElement,
                              [name]: {
                                ...innerElement[name],
                                [language]: value,
                              },
                            },
                          ]);
                        }
                        return innerElementsAcc.concat([innerElement]);
                      }, []),
                    },
                  ]);
                }
                return elementsAcc.concat([el]);
              }, []),
            },
          ]);
        }
        return acc.concat([section]);
      }, []),
    }));
  }

  onUploadIcon(e, innerElementPosition) {
    const { onChange, sectionNumber, element } = this.props;
    const reader = new FileReader();
    const file = e.target.files[0];

    if (file) {
      reader.onloadend = () => {
        onChange(prevState => ({
          offerSections: prevState.offerSections.reduce((acc, section) => {
            if (section.position === sectionNumber) {
              return acc.concat([
                {
                  ...section,
                  elements: section.elements.reduce((elementsAcc, el) => {
                    if (element.position === el.position) {
                      return elementsAcc.concat([
                        {
                          ...el,
                          elements: (el.elements || []).reduce((innerElementsAcc, innerElement) => {
                            if (innerElement.position === innerElementPosition) {
                              return innerElementsAcc.concat([
                                {
                                  ...innerElement,
                                  file: {
                                    base64: reader.result,
                                    fileName: file.name,
                                    delete: false,
                                  },
                                },
                              ]);
                            }
                            return innerElementsAcc.concat([innerElement]);
                          }, []),
                        },
                      ]);
                    }
                    return elementsAcc.concat([el]);
                  }, []),
                },
              ]);
            }
            return acc.concat([section]);
          }, []),
        }));
      };

      reader.readAsDataURL(file);
    }
  }

  onAddGridItem() {
    const { onChange, sectionNumber, element } = this.props;

    onChange(prevState => ({
      offerSections: prevState.offerSections.reduce((acc, section) => {
        if (section.position === sectionNumber) {
          return acc.concat([
            {
              ...section,
              elements: section.elements.reduce((elementsAcc, el) => {
                if (element.position === el.position) {
                  const existingElements = el.elements || [];
                  const nextPosition = existingElements?.[existingElements.length - 1]?.position + 1 || 1;
                  const nextBackendIndex = existingElements?.[existingElements.length - 1]?.backendIndex + 1 || 0;

                  return elementsAcc.concat([
                    {
                      ...el,
                      elements: existingElements.concat([
                        {
                          ...GridElementItemModel,
                          position: nextPosition,
                          backendIndex: nextBackendIndex,
                        },
                      ]),
                    },
                  ]);
                }
                return elementsAcc.concat([el]);
              }, []),
            },
          ]);
        }
        return acc.concat([section]);
      }, []),
    }));
  }

  onRemoveGridItem(innerElementPosition) {
    const { onChange, sectionNumber, element } = this.props;

    // eslint-disable-next-line no-restricted-globals
    if (confirm(`Are you sure you want to remove grid item #${innerElementPosition}? Changes will be discarded.`)) {
      onChange(prevState => ({
        offerSections: prevState.offerSections.reduce((acc, section) => {
          if (section.position === sectionNumber) {
            return acc.concat([
              {
                ...section,
                elements: section.elements.reduce((elementsAcc, el) => {
                  if (element.position === el.position) {
                    return elementsAcc.concat([
                      {
                        ...el,
                        elements: (el.elements || []).reduce((innerElementsAcc, innerElement) => {
                          if (innerElement.position === innerElementPosition) {
                            return innerElementsAcc;
                          }
                          if (innerElement.position > innerElementPosition) {
                            return innerElementsAcc.concat([{ ...innerElement, position: innerElement.position - 1 }]);
                          }
                          return innerElementsAcc.concat([innerElement]);
                        }, []),
                      },
                    ]);
                  }
                  return elementsAcc.concat([el]);
                }, []),
              },
            ]);
          }
          return acc.concat([section]);
        }, []),
      }));
    }
  }

  onArrowUp(innerElementPosition) {
    const { onChange, sectionNumber, element } = this.props;

    onChange(prevState => ({
      offerSections: prevState.offerSections.reduce((acc, section) => {
        if (section.position === sectionNumber) {
          return acc.concat([
            {
              ...section,
              elements: section.elements.reduce((elementsAcc, el) => {
                if (element.position === el.position) {
                  return elementsAcc.concat([
                    {
                      ...el,
                      elements: (el.elements || []).reduce((innerElementsAcc, innerElement) => {
                        const prevItem = (el.elements || []).find(item => item.position === innerElementPosition - 1);
                        const matchingItem = (el.elements || []).find(item => item.position === innerElementPosition);

                        if (!prevItem || !matchingItem) {
                          return innerElementsAcc.concat([innerElement]);
                        }

                        if (innerElement.position === prevItem.position) {
                          return innerElementsAcc.concat({ ...matchingItem, position: prevItem.position });
                        }
                        if (innerElement.position === matchingItem.position) {
                          return innerElementsAcc.concat({ ...prevItem, position: matchingItem.position });
                        }
                        return innerElementsAcc.concat([innerElement]);
                      }, []),
                    },
                  ]);
                }
                return elementsAcc.concat([el]);
              }, []),
            },
          ]);
        }
        return acc.concat([section]);
      }, []),
    }));
  }

  onArrowDown(innerElementPosition) {
    const { onChange, sectionNumber, element } = this.props;

    onChange(prevState => ({
      offerSections: prevState.offerSections.reduce((acc, section) => {
        if (section.position === sectionNumber) {
          return acc.concat([
            {
              ...section,
              elements: section.elements.reduce((elementsAcc, el) => {
                if (element.position === el.position) {
                  return elementsAcc.concat([
                    {
                      ...el,
                      elements: (el.elements || []).reduce((innerElementsAcc, innerElement) => {
                        const nextItem = (el.elements || []).find(item => item.position === innerElementPosition + 1);
                        const matchingItem = (el.elements || []).find(item => item.position === innerElementPosition);

                        if (!nextItem || !matchingItem) {
                          return innerElementsAcc.concat([innerElement]);
                        }

                        if (innerElement.position === nextItem.position) {
                          return innerElementsAcc.concat({ ...matchingItem, position: nextItem.position });
                        }
                        if (innerElement.position === matchingItem.position) {
                          return innerElementsAcc.concat({ ...nextItem, position: matchingItem.position });
                        }
                        return innerElementsAcc.concat([innerElement]);
                      }, []),
                    },
                  ]);
                }
                return elementsAcc.concat([el]);
              }, []),
            },
          ]);
        }
        return acc.concat([section]);
      }, []),
    }));
  }

  render() {
    const { element, elementErrors, t, isViewMode } = this.props;
    const gridItems = [...(element?.elements || [])].sort((a, b) => a.position - b.position);

    return (
      <>
        {isViewMode ? null : (
          <Form.Group>
            <Grid container stackable columns={1} divided>
              <Grid.Row>
                <Button color="green" onClick={this.onAddGridItem}>
                  <Icon name="plus" />
                  {t('grid.newItem')}
                </Button>
              </Grid.Row>
            </Grid>
          </Form.Group>
        )}
        {gridItems.map(innerElement => {
          const disableArrowUp = innerElement.position === gridItems[0]?.position;
          const disableArrowDown = innerElement.position === gridItems[gridItems.length - 1]?.position;
          const iconSrc = innerElement?.file?.base64 || innerElement?.iconUrl || innerElement?.imageUrl;

          return (
            <Segment key={innerElement.position}>
              <Form.Group>
                <Grid container stackable columns={1} divided>
                  <Grid.Row verticalAlign="middle">
                    <Label>
                      {innerElement.position}. {t('grid.item')}
                    </Label>
                    {isViewMode ? null : (
                      <>
                        <Button
                          icon
                          className="mr-2 ml-2"
                          disabled={disableArrowUp}
                          onClick={() => this.onArrowUp(innerElement.position)}
                        >
                          <Icon name="arrow up" />
                        </Button>
                        <Button
                          icon
                          className="mr-2 ml-2"
                          disabled={disableArrowDown}
                          onClick={() => this.onArrowDown(innerElement.position)}
                        >
                          <Icon name="arrow down" />
                        </Button>
                        <Button
                          icon
                          className="mr-2 ml-2"
                          color="red"
                          onClick={() => this.onRemoveGridItem(innerElement.position)}
                        >
                          <Icon name="trash" />
                        </Button>
                      </>
                    )}
                  </Grid.Row>
                </Grid>
              </Form.Group>
              <Form.Group>
                <Grid container stackable columns={1} divided>
                  <TranslatableTextField
                    disabled={isViewMode}
                    icon="font"
                    label={t('grid.title')}
                    name="title"
                    errorMessage={elementErrors?.elements?.[innerElement?.backendIndex]?.title}
                    value={innerElement.title}
                    onChange={(e, data) =>
                      this.onChangeTranslatableContent(e, {
                        ...data,
                        innerElementPosition: innerElement.position,
                      })
                    }
                  />
                  <TranslatableRichTextField
                    disabled={isViewMode}
                    label={t('grid.description')}
                    name="description"
                    errorMessage={elementErrors?.elements?.[innerElement?.backendIndex]?.description}
                    value={innerElement.description}
                    onChange={(e, data) =>
                      this.onChangeTranslatableContent(e, {
                        ...data,
                        innerElementPosition: innerElement.position,
                      })
                    }
                  />
                </Grid>
              </Form.Group>
              <Segment>
                <Grid container stackable columns={isViewMode ? 1 : 2} divided verticalAlign="middle">
                  <Grid.Column>
                    {iconSrc ? (
                      <Image src={iconSrc} size="small" rounded bordered />
                    ) : (
                      <Label basic color="grey">
                        {t('grid.noIcon')}
                      </Label>
                    )}
                  </Grid.Column>
                  {isViewMode ? null : (
                    <Grid.Column>
                      <Form.Field>
                        <label>{t('grid.icon')}</label>
                        <Input
                          type="file"
                          accept={VALID_IMAGE_MIME_TYPES.join(', ')}
                          onChange={e => this.onUploadIcon(e, innerElement.position)}
                        />
                      </Form.Field>
                    </Grid.Column>
                  )}
                </Grid>
              </Segment>
            </Segment>
          );
        })}
      </>
    );
  }
}

export default withTranslation(TRANSLATIONS.OFFERS)(GridElement);
